// The medication administration record (docs/plans/phase2-emar-inpatient-pharmacy.md §4).
export { doseSchedule, durationInDays } from './schedule.ts';
export type { OrderFrequencyKind, ScheduleInput } from './schedule.ts';
export {
  ADMINISTRATION_OUTCOMES,
  DOSE_STATES,
  DOSE_TIMINGS,
  doseState,
  doseTiming,
  prnGivenInLastDay,
} from './timing.ts';
export type { AdministrationOutcome, DoseState, DoseTiming, EmarWindows } from './timing.ts';
export {
  ADMINISTRATION_ERRORS,
  checkAdministration,
  checkEmarWindows,
  EMAR_ALERT_RULES,
  EMAR_REASON_MAX,
  EMAR_REASON_MIN,
  EMAR_WINDOW_MAX_MINUTES,
} from './administration.ts';
export type { AdministrationErrorCode } from './administration.ts';

export const MEDICATION_SUPPLIES = ['patient_supply', 'ward_stock'] as const;
export type MedicationSupply = (typeof MEDICATION_SUPPLIES)[number];

/** The medicines chart shows doses from this long ago to this far ahead (display only). */
export const EMAR_CHART_LOOKBACK_HOURS = 24;
export const EMAR_CHART_LOOKAHEAD_HOURS = 12;
